var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"uk-container"},[_c('WelcomeCard')],1),_c('TransactionList'),(this.$store.state.context.actingAsBusiness)?_c('MymoCardBusiness'):_vm._e(),(!this.$store.state.context.actingAsBusiness)?_c('MymoCard'):_vm._e(),(_vm.loadingTour)?_c('div'):_vm._e(),_c('Tour')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }